import React, { useState } from 'react'
import Button from '../../shared/Button'
import Countdown, { CountdownApi } from "react-countdown";
import PersianNumber from '../../shared/PersianNumber';

const TimetoResponde = () => {
  const [running, setRunning] = useState(true);

  return (
    <div className='TimetoResponde'>
      <h3>
      زمان باقی مانده تا
      <span>
      پاسخگویی
      </span>
      </h3>
      <div className='TimetoResponde--timer'>
      <Countdown
                  zeroPadTime={3}
                  date={Date.now() + 1800000}
                  autoStart={running}
                  onComplete={()=>setRunning(false)}
                  renderer={({ hours, minutes, seconds, completed }) => {
                    return (
                      <div className='flex flex-row-reverse'>
                        <PersianNumber number={hours} /> :
                        <PersianNumber number={minutes} /> :
                        <PersianNumber number={seconds} />
                      </div>
                    );
                  }}
                />
      </div>
      <Button varient="outlined"> تماس با پشتیبانی </Button>
    </div>
  )
}

export default TimetoResponde